export default __webpack_public_path__ + "static/media/Montreal en lumiere - Logo2.9736119f.png";